<template>
    <el-dialog :visible.sync="visible" top="5%" title="图片预览" width="1200px" :close-on-click-modal="false">
        <el-row type="flex" justify="center">
            <img :src="url" alt="" style="max-width: 100%; max-height: 75vh" />
        </el-row>
    </el-dialog>
</template>

<script>
import { ossUrl } from "@/configs/oss";

export default {
    data() {
        return {
            ossUrl,
            visible: false,
            url: "",
        };
    },
    methods: {
        open(url) {
            this.url = ossUrl + url;
            this.visible = true;
        },
    },
};
</script>

<style></style>
